import { c as _c } from "react/compiler-runtime";
import { Tooltip } from 'design-system/client';
import { useTranslations } from 'next-intl';
import styles from './TaxDeductibilityNotice.module.css';
function TaxDeductibilityNotice() {
  const $ = _c(9);
  const t = useTranslations("nextjs.donate.iframe");
  let t0;
  if ($[0] !== t) {
    t0 = t("tax_deductibility_notice_tooltip");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("tax_deductibility_notice");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <span className="colorOverride">{t1}</span>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t2) {
    t3 = <div className={styles.taxDeductibilityNotice}><Tooltip content={t0} id="tooltip-for-tax-deductibility">{t2}</Tooltip></div>;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export default TaxDeductibilityNotice;